import React from 'react';
import './SquareButtons.css';

const SquareButtons = ({ state, setState, toggleLowContrast, toggleReducedMotion, lowContrast }) => {
  const toggleFullscreen = () => {
    const element = document.documentElement;

    if (state.isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen().catch((err) => console.error(`Error exiting fullscreen mode: ${err.message} (${err.name})`));
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
      }
    } else {
      if (element.requestFullscreen) {
        element.requestFullscreen().catch((err) => console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`));
      } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) { // Firefox
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) { // IE/Edge
        element.msRequestFullscreen();
      }
    }

    setState((prevState) => ({
      ...prevState,
      isFullscreen: !prevState.isFullscreen,
    }));
  };

  const toggleInfo = () => {
    setState((prevState) => ({
      ...prevState,
      isInfo: !prevState.isInfo,
    }))
  };

  return (
    <div id="options-container">
      <button id="fullscreen-button" className={`optionbutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={toggleFullscreen} onTouchStart={toggleFullscreen}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-maximize-2">
          <polyline points="15 3 21 3 21 9"></polyline>
          <polyline points="9 21 3 21 3 15"></polyline>
          <line x1="21" y1="3" x2="14" y2="10"></line>
          <line x1="3" y1="21" x2="10" y2="14"></line>
        </svg>
      </button>
      <button id="lowcontrast" className={`optionbutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={toggleLowContrast} onTouchStart={toggleLowContrast}>
        <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
          <path className="cls-2" d="M21.6,12c0,5.3-4.2,9.6-9.5,9.6V2.4c5.2,0,9.5,4.3,9.5,9.6Z" fill='currentColor'/>
          <polygon className="cls-2" points="12.2 2 12.2 22 15.6 21.4 19.3 18.9 21.4 15.5 22 11 21.2 8 19.2 5 17.1 3 12.2 2" stroke="currentColor" strokeWidth="2"/>
          <circle className="cls-1" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        </svg>
      </button>
      <button id="reducemotion" className={`optionbutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={toggleReducedMotion} onTouchStart={toggleReducedMotion}>
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" version="1.2" viewBox="0 0 24 24">
          <path d="M3.1,15.6s0,0,.1.1c-.9-.2-1.7-.4-2.5-.6-.8-.2-.9-1.3-.2-1.7.4-.3,1.2-.6,1.9-.9-.1,1.1.1,2.3.8,3.1Z" fill="CurrentColor" strokeWidth="0"/>
          <path d="M16.6,16.8c.5,0,.9-.2,1.4-.4v.8c0,1.1-.9,2-2,2h-.8c-1.1,0-1.9-.9-1.9-2h0c1.1-.2,2.2-.3,3.3-.4h0Z" fill="CurrentColor" strokeWidth="0"/>
          <path d="M5.3,16.8c1.3.1,2.5.2,3.8.3h0c0,1.2-.9,2.1-2,2.1h-.8c-1.1,0-2-.9-2-2v-.6c.3.1.6.2.9.2Z" fill="CurrentColor" strokeWidth="0"/>
          <path d="M24,8.6c0,.6-.4,1.1-.9,1.1-.3,0-.7,0-1,0-.3,2.1-1.4,3.6-2.7,4.7.3-.9.3-1.9,0-2.8-.4-1.2-.9-2.3-1.5-3.2.1-.2.2-.4.3-.5,0,0,0-.2.3-.5.6-1,1.5-1.6,2.6-1.6s2.5.9,2.9,2.4c0,.1,0,.3,0,.4Z" fill="CurrentColor" strokeWidth="0"/>
          <path d="M19,11.8c-.3-1.1-.8-2.1-1.4-3-1.6-2.5-4-4-6.7-4s-3.5.7-4.9,1.9c-1.4,1.2-2.5,3-3.2,5.1,0,.1,0,.3-.1.5-.3,1.4.2,2.9,1.1,3.6.1.1.3.2.5.3.3.1.6.2.9.2,1.3.1,2.5.2,3.8.3.7,0,1.4,0,2,0s1.5,0,2.2,0c1.1,0,2.2-.1,3.3-.3.5,0,1-.2,1.4-.5.3-.2.5-.5.7-.9.3-.6.5-1.2.5-2s0-.8-.2-1.3Z" fill="CurrentColor" strokeWidth="0"/>
        </svg>
      </button>
      <button id="info" className={`optionbutton ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={toggleInfo} onTouchStart={toggleInfo}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-info">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </button>
    </div>
  );
};

export default SquareButtons;
